export function getInitialState() {
  const initialState = {
    measure: [],
    isOpenOverlay: false,
    currentEditedRow: '',
  };

  return initialState;
}
